var _path, _line, _path2, _line2, _line3, _line4, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.276,2.973h7.011c1.34,0,2.428,1.088,2.428,2.428v15.627H2.849V5.4c0-1.34,1.088-2.428,2.428-2.428Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.348,
    y1: 8.91,
    x2: 14.228,
    y2: 8.91
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.715,8.91h2.402c2.226,0,4.034,1.808,4.034,4.034v8.084h-6.436v-12.117h0Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.348,
    y1: 12.751,
    x2: 14.228,
    y2: 12.751
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 17.813,
    y1: 12.751,
    x2: 20.808,
    y2: 12.751
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.348,
    y1: 16.592,
    x2: 14.228,
    y2: 16.592
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 17.813,
    y1: 16.592,
    x2: 21.151,
    y2: 16.592
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.c223ae1d0d0c553d8e3c9e819965b6e0.svg";
export { ForwardRef as ReactComponent };